<!--
 * @Author: dingguowei
 * @Date: 2023-06-14 10:02:46
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-06-21 14:31:31
-->
<!-- 我的任务单个任务组件 -->
<template>
  <div>
    <el-card class="hallitem">
      <div class="title">
        <p style="font-size: 0.9rem; font-weight: 600">{{ taskData.title }}</p>
        <p style="font-size: 0.6rem; color: #999999">
          截止时间:{{ taskData.endAt }}
        </p>
      </div>
      <div class="ask">
        <p style="font-size: 0.8rem; font-weight: 600">任务要求</p>
        <div class="askbody">
          <div class="askitem" v-for="(item, index) in askSetting" :key="index">
            <div>
              <p style="color: #5874ef">
                {{
                  taskData.salaryListVos[0][item.fieID] &&
                  taskData.salaryListVos[0][item.fieID] !== null
                    ? taskData.salaryListVos[0][item.fieID]
                    : "-"
                }}
              </p>
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="num">
        <span :style="{ color: textColor(taskData.userStatus) }">{{
          statusText(taskData.userStatus)
        }}</span>
        <el-button
          v-if="
            taskData.userStatus === 'TOFINISH' ||
            taskData.userStatus === 'TOJUDGE'
          "
          round
          size="mini"
          style="margin-left: auto; color: #fff; background-color: #e6a23c"
          @click="closeTask(taskData)"
        >
          关闭任务
        </el-button>
        <el-button
          round
          size="mini"
          style="color: #fff"
          :style="{
            backgroundColor:
              taskData.userStatus === 'CLOSED' ? '#999999' : '#5874EF',
          }"
          @click="receive(taskData)"
        >
          查看详情
        </el-button>
      </div>
    </el-card>
  </div>
</template>
  
  <script>
import { userclose } from "@/api/user";
import router from "@/router";
import store from "@/store";
export default {
  props: {
    taskData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      askSetting: [
        {
          name: "互动数",
          fieID: "totalNum",
        },
        {
          name: "点赞数",
          fieID: "likeNum",
        },
        {
          name: "收藏数",
          fieID: "collectNum",
        },
        {
          name: "评论数",
          fieID: "commentNum",
        },
        {
          name: "转发数",
          fieID: "shareNum",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    statusText() {
      return function (val) {
        if (val === "TOJUDGE") {
          return "待审核";
        } else if (val === "CLOSED") {
          return "已关闭";
        } else if (val === "FINISHED") {
          return "通过";
        } else if (val === "REFUSED") {
          return "拒绝";
        } else if (val === "FORBID") {
          return "拉黑";
        } else if (val === "TOFINISH") {
          return "进行中";
        }
      };
    },
    textColor() {
      return function (val) {
        if (val === "TOJUDGE") {
          return "#cb2dcd";
        } else if (val === "CLOSED") {
          return "#999999";
        } else if (val === "FINISHED") {
          return "#7ce546";
        } else if (val === "REFUSED") {
          return "#e18b32";
        } else if (val === "FORBID") {
          return "#c92626";
        } else if (val === "TOFINISH") {
          return "#5874EF";
        }
      };
    },
  },
  methods: {
    receive(val) {
      store.commit("task/CHANGE_publisherAccount", val.publisherAccount);
      store.commit("task/CHANGE_publisherId", val.publisherId);
      store.commit("task/CHANGE_MISSIONID", val.id);
      store.commit("user/CHANGE_userCurTaskStatus", val.userStatus);
      store.commit("task/CHANGE_missionReceiveId", val.missionReceiveId);
      router.push({ path: "/userDetails" });
    },
    closeTask(val) {
      var that = this;
      userclose({
        missionReceiveId: val.missionReceiveId,
      }).then((res) => {
        if (res.code === 1000) {
          this.$message({
            message: "成功关闭任务",
            type: "success",
          });
          that.$emit("closeTask");
        } else {
          this.$message.error("关闭任务失败");
        }
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
.hallitem {
  font-family: PingFangSC-Regular, PingFang SC;
  .title {
    line-height: 160%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ask {
    margin-top: 10px;

    .askbody {
      padding: 7px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .askitem {
        text-align: center;
        flex: 1;
        flex-wrap: nowrap;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        // justify-content: space-between;
      }
    }
  }

  .num {
    margin-top: 10px;
    display: flex;

    & span {
      //   padding: 6px 10px;
      display: inline-block;
      flex: 1;
      // width: 14rem;
      font-size: 1rem;
      font-weight: 600;
      //   background-color: #f6f6f6;
      //   border-radius: 1rem;
    }
  }
}
</style>